import {put, takeEvery, call} from 'redux-saga/effects';
import {START_SYNC} from '../constants';
import {startSyncRequest, startSyncSuccess, startSyncFailure} from '../actions';

import Api, {ApiMethods} from 'feedback-system/middleware/api';

import {StartSyncRequest, StartSyncSuccess, StartSyncFailure} from '../typedef';

type IActions = StartSyncRequest | StartSyncSuccess | StartSyncFailure;

function* sagaStartSyncData(action: IActions) {
    try {
        yield put(startSyncRequest());

        yield call(Api.fetch, {
            endpoint: 'synchronize',
            method: ApiMethods.GET
        });

        yield put(startSyncSuccess(true));
    } catch (e) {
        yield put(startSyncFailure());
    }
}

function* startSyncSaga() {
    yield takeEvery(START_SYNC, sagaStartSyncData);
}

export {startSyncSaga};
